import React from 'react';

import {
    Container as MaterialContainer,
    Grid,
} from '@sunwisesoftware/sunwise-ui';
import { useTranslation } from 'react-i18next';

import { HeaderContainer, TitleIcon } from 'common/components';

import DataForm from './components/DataForm';

const Container = () => {
    const { t } = useTranslation();
    return (
        <MaterialContainer maxWidth={false}>
            <HeaderContainer>
                <Grid size="grow">
                    <TitleIcon title={t('General')} />
                </Grid>
            </HeaderContainer>
            <DataForm />
        </MaterialContainer>
    );
};

Container.propTypes = {};

export default Container;
